import { IOrderPositions, IOrderStatus, IPreorderStatus } from 'my-poppies-b2b-types';
import { useContext } from 'react';

import { colors } from '@/colors';
import { Container } from '@/components/Container';
import { KeyValuePair } from '@/components/KeyValuePair';
import { DataContext } from '@/contexts/DataContext';
import useTranslation from '@/hooks/useTranslation';

interface IProductsOnOrderProps {
  id: string;
  status: IOrderStatus | IPreorderStatus;
  positions?: IOrderPositions;
  position?: string;
  total?: number;
}

export const OrderProducts = (props: IProductsOnOrderProps) => {
  const { positions, id, status, position, total } = props;
  const isInternalOrder = status === 'INTERNAL_ORDER_COMPLETED';
  const usedPositions: IOrderPositions = isInternalOrder
    ? [
        {
          positionId: position ?? '',
          amount: total ?? 0,
        },
      ]
    : (positions ?? []);

  const t = useTranslation();
  const { getProductTitleById } = useContext(DataContext);
  return (
    <Container
      debugColor={'rosybrown'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0px',
        fontSize: 12,
        borderRadius: '4px',
        padding: '8px 0',
      }}
    >
      {usedPositions.map((productWithQuantity, index) => {
        const isFirst = index === 0;
        const isLast = index === usedPositions.length - 1;
        return (
          <Container
            debugColor={'green'}
            key={`new-order-${id}-${productWithQuantity.positionId}`}
            sx={{
              padding: '4px 8px',
              paddingTop: isFirst ? '8px' : undefined,
              borderTopLeftRadius: isFirst ? '8px' : undefined,
              borderTopRightRadius: isFirst ? '8px' : undefined,
              paddingBottom: isLast ? '8px' : undefined,
              borderBottomLeftRadius: isLast ? '8px' : undefined,
              borderBottomRightRadius: isLast ? '8px' : undefined,
              backgroundColor: index % 2 === 0 ? colors.grayMedium : colors.gray,
              display: 'flex',
              flexDirection: 'row',
              flexGrow: 1,
            }}
          >
            <Container debugColor={'orange'} sx={{ flexGrow: 1, textAlign: 'left' }}>
              <KeyValuePair
                addColon
                keyName={`${t('order.position.pos')} ${index + 1}`}
                value={
                  isInternalOrder ? productWithQuantity.positionId : getProductTitleById(productWithQuantity.positionId)
                }
              />
            </Container>
            <Container debugColor={'yellow'} sx={{ marginLeft: 8, flexGrow: 0, flexBasis: '96px', textAlign: 'right' }}>
              <KeyValuePair addColon keyName={t('order.position.amount')} value={productWithQuantity.amount} />
            </Container>
          </Container>
        );
      })}
    </Container>
  );
};
